import Vue from 'vue'
import App from './app/App.vue'
import router from './router'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import Notifications from 'vue-notification'
Vue.use(Notifications)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import 'vue-select/dist/vue-select.css';

require('@fortawesome/fontawesome-free/css/all.css');

require("vue-suggestion/dist/vue-suggestion.css");

import 'animate.css'

import './assets/scss/app.scss';

import "animate.css"


import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

Vue.config.productionTip = false

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

import VueMixpanel from 'vue-mixpanel'
Vue.use(VueMixpanel, {
  token: process.env.VUE_APP_MIXPANEL_TOKEN,
  config: {
    debug: process.env.VUE_APP_MIXPANEL_DEBUG
  }
})

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

 
 

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
